module.exports = __webpack_public_path__ + "img/ipro_logo.99e460fc.png";